import { render, staticRenderFns } from "./VisualizarFornecedoresDialog.vue?vue&type=template&id=1075b89e&scoped=true"
import script from "./VisualizarFornecedoresDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarFornecedoresDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075b89e",
  null
  
)

export default component.exports